/* eslint-disable no-use-before-define */
import React from 'react'
import { Chart } from './chart'
import { Table } from './table'

export const ChartOrTable = ({chartData, bondInfo}) => {

    const [show, setShow] = React.useState('chart')

    return <React.Fragment>
        <div className="vertical-offset-xxs">
        <div className="text-body text-bold" style={{display:'inline'}}>
            {`Yield to Maturity${bondInfo.isCallable ? '/Call' : ''} `}
        </div>

        <div className='select-wrapper inline text-bold' style={getSelectStyle()}>
            <select
                aria-label={`show yield to maturity ${bondInfo.isCallable ? '/call' : ''} chart or table`}
                defaultValue={show}
                style={{paddingRight:'35px'}}
                onChange={(e) => setShow(e.target.value)}
                >
                <option value='chart'>chart</option>
                <option value='table'>table</option>
            </select>
        </div>
        </div>

        {show==='chart' && <Chart chartData={chartData} bondInfo={bondInfo} />}
        {show==='table' && <Table chartData={chartData} bondInfo={bondInfo} />}
    </React.Fragment>
}

const getSelectStyle = () => {
    const color = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-base-color')
        .trim() || '#5627d8'
    console.log(color)
    return {
        display: 'inline',
        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#','%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'calc(100% - 7px) 50%',
    }
}


// WEBPACK FOOTER //
// ./src/calculator/calc-output/chart-or-table.js